import { useEffect, useRef, useState } from 'react'

type Timer = ReturnType<typeof setTimeout>;

export function useDebounce<Func extends (...args: any[]) => void>(func: Func, delay: number = 1000) {
    const timer = useRef<Timer>();

    useEffect(() => {
      return () => {
        if (!timer.current) return;
        clearTimeout(timer.current);
      };
    }, []);
  
    const debouncedFunction = ((...args) => {
      const newTimer = setTimeout(() => {
        func(...args);
      }, delay);
      clearTimeout(timer.current);
      timer.current = newTimer;
    }) as Func;
  
    return debouncedFunction;
}